import PropTypes from "prop-types"
import styled from "styled-components"

const TextWrapper = styled.div`
  display: flex;
  &.manage-contacts-textwrapper{
    width: 30%;
  }
    ${({ theme }) => theme.se`
    width: 100%;
    flex-direction: column;
    order: 2;
    &.manage-contacts-textwrapper{
    width: 93%;
  }
  `}
    ${({ theme }) => theme.tablet`
    &.testimonial-text-wrapper{
      width: 70%;
      margin: 0 auto;
    }
  `}
    ${({ theme }) => theme.desktop`
    width: ${({ long }) => (long ? "60%" : "48%")};
    order: ${({ imageLeft }) => (imageLeft ? 2 : 1)};
    &.manage-contacts-textwrapper{
    width: 30%;
    }
     &.testimonial-text-wrapper{
      width: 60%;
      margin: 0 auto;
    }  
  `}
    ${({ theme }) => theme.largeDesktop`
  `}
    h3 {
    margin-bottom: 30px;
  }
`

TextWrapper.propTypes = {
  imageLeft: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

TextWrapper.defaultProps = {
  imageLeft: false,
}

export default TextWrapper
